// Reusable JSON-LD schema builders for SEO
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from '../components/SEO';

export const COMPANY_PHONE = '+1-667-455-6368';
export const COMPANY_EMAIL = 'Jetcoelectricllc@gmail.com';

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'Electrician',
  name: SITE_NAME,
  image: DEFAULT_OG_IMAGE,
  url: SITE_URL,
  telephone: COMPANY_PHONE,
  email: COMPANY_EMAIL,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '647 E 89th St',
    addressLocality: 'Brooklyn',
    addressRegion: 'NY',
    postalCode: '11236',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 40.6418,
    longitude: -73.9137,
  },
  areaServed: [
    { '@type': 'City', name: 'Brooklyn', sameAs: 'https://en.wikipedia.org/wiki/Brooklyn' },
    { '@type': 'City', name: 'Queens', sameAs: 'https://en.wikipedia.org/wiki/Queens' },
    { '@type': 'City', name: 'Manhattan', sameAs: 'https://en.wikipedia.org/wiki/Manhattan' },
  ],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '07:00',
      closes: '20:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday', 'Sunday'],
      opens: '08:00',
      closes: '18:00',
    },
  ],
  priceRange: '$$',
  paymentAccepted: ['Cash', 'Credit Card', 'Check'],
  currenciesAccepted: 'USD',
  sameAs: [
    'https://www.instagram.com/jetcoelectricalcontractor',
    'https://www.tiktok.com/@jetco_electrical',
    'https://www.facebook.com/jetcoelectrical',
    'https://www.yelp.com/biz/jetco-electrical-contractors-brooklyn',
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5',
    reviewCount: '47',
  },
};

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const serviceSchema = ({ name, description, slug, image, faqs }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: name,
  name,
  description,
  image,
  url: `${SITE_URL}/services/${slug}`,
  provider: {
    '@type': 'Electrician',
    name: SITE_NAME,
    telephone: COMPANY_PHONE,
    url: SITE_URL,
  },
  areaServed: [
    { '@type': 'City', name: 'Brooklyn' },
    { '@type': 'City', name: 'Queens' },
    { '@type': 'City', name: 'Manhattan' },
  ],
  ...(faqs?.length
    ? {
        mainEntityOfPage: {
          '@type': 'FAQPage',
          mainEntity: faqs.map((f) => ({
            '@type': 'Question',
            name: f.question,
            acceptedAnswer: { '@type': 'Answer', text: f.answer },
          })),
        },
      }
    : {}),
});

export const faqPageSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.question,
    acceptedAnswer: { '@type': 'Answer', text: f.answer },
  })),
});

export const blogPostingSchema = ({ title, description, slug, image, author, date }) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: title,
  description,
  image,
  datePublished: date,
  dateModified: date,
  author: { '@type': 'Organization', name: author || SITE_NAME },
  publisher: {
    '@type': 'Organization',
    name: SITE_NAME,
    logo: { '@type': 'ImageObject', url: DEFAULT_OG_IMAGE },
  },
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': `${SITE_URL}/blog/${slug}`,
  },
});

export const blogListingSchema = (posts) => ({
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: `${SITE_NAME} Blog`,
  url: `${SITE_URL}/blog`,
  blogPost: posts.slice(0, 10).map((p) => ({
    '@type': 'BlogPosting',
    headline: p.title,
    url: `${SITE_URL}/blog/${p.slug}`,
    datePublished: p.date,
    description: p.excerpt,
    image: p.image,
  })),
});
